<template>
  <div class="icon-link">
    <cv-button kind="tertiary" class="icon-button" :disabled="disabled" @click="handleClick">
      <svg-icon :name="icon" kind="action" />
    </cv-button>
    <cv-link :disabled="disabled" @click="handleClick">
      {{ label }}
    </cv-link>
  </div>
</template>

<script setup lang="ts">
// Props
interface Props {
  disabled?: boolean;
  icon: string;
  label: string;
}

const { disabled = false, icon, label } = defineProps<Props>();

// Emits
const emit = defineEmits<{
  clicked: [data: unknown];
}>();

// Methods
const handleClick = (event) => {
  emit("clicked", event);
};
</script>

<style lang="scss">
@import "@styles/themes/sls-theme/tokens/spacing";
@import "@styles/themes/sls-theme/tokens/typo";

.icon-link {
  display: flex;
  align-items: center;
  margin-bottom: $spacing-05;

  > .bx--link {
    @include carbon--type-style("productive-heading-01", true);
    margin-left: $spacing-03;
  }
}
</style>
